import { z } from "zod";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { businessDayOffsetSchema } from "./enums.js";
/**
 * Vardiya şablonları (`shift_templates`): istasyonun tipik vardiya pencereleri.
 *
 * `endTime <= startTime` ise vardiya ERTESİ gün biter (22:00–06:00). İş günü varsayılan olarak vardiyanın
 * BAŞLADIĞI İstanbul takvim günüdür; `businessDayOffset` ile kaydırılır (AGENTS.md §3.3).
 */
export const shiftTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):([0-5]\d)$/, "Saat HH:MM biçiminde olmalıdır")
    .describe("İstanbul yerel saati (HH:MM)");
/** 24 saatlik kapsama denetimi — bilgilendirmedir; boşluk 24 saat açık olmayan istasyonda olağandır. */
export const templateCoverageSchema = z.object({
    gaps: z
        .array(z.object({ from: z.number().int(), to: z.number().int() }))
        .describe("Hiçbir şablonun kapsamadığı dakika aralıkları [from, to) — gün içi dakika (0…1440)"),
    overlaps: z
        .array(z.object({ from: z.number().int(), to: z.number().int() }))
        .describe("Birden çok şablonun çakıştığı dakika aralıkları"),
});
export const shiftTemplateSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    name: z.string(),
    startTime: shiftTimeSchema,
    endTime: shiftTimeSchema,
    businessDayOffset: businessDayOffsetSchema,
    /** Şablonun süresi (dk); ertesi güne sarkan vardiyada 24 saati aşmaz. */
    durationMinutes: z.number().int().positive(),
    crossesMidnight: z.boolean(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
    createdAt: timestampSchema,
    version: z.number().int().min(1),
});
export const createShiftTemplateSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema,
    name: z.string().trim().min(1).max(60),
    startTime: shiftTimeSchema,
    endTime: shiftTimeSchema,
    businessDayOffset: businessDayOffsetSchema.default(0),
    sortOrder: z.number().int().min(0).max(999).default(0),
});
/** Kısmi güncelleme: gönderilmeyen alan değişmez. */
export const updateShiftTemplateSchema = z.object({
    name: z.string().trim().min(1).max(60).optional(),
    startTime: shiftTimeSchema.optional(),
    endTime: shiftTimeSchema.optional(),
    businessDayOffset: businessDayOffsetSchema.optional(),
    sortOrder: z.number().int().min(0).max(999).optional(),
    isActive: z.boolean().optional(),
    version: z.number().int().min(1),
});
export const listShiftTemplatesQuerySchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    includeInactive: z
        .enum(["true", "false"])
        .default("false")
        .transform((value) => value === "true"),
});
/** Liste sayfalanmaz: bir istasyonda en çok birkaç şablon olur ve kapsama denetimi TÜMÜNÜ ister. */
export const shiftTemplateListSchema = z.object({
    items: z.array(shiftTemplateSchema),
    coverage: z
        .array(z.object({ stationId: uuidSchema, ...templateCoverageSchema.shape }))
        .describe("İstasyon başına 24 saat kapsama denetimi (yalnızca ETKİN şablonlar)"),
});
export const templateParamsSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=templates.js.map